import OptionPage from "../components/optionPageStructure";
import { checkMissingSelections } from "../utils/checkMissingSelections";

export default function ElectricalAppliances() {
  return (
    <OptionPage
      title="Sähkökalusteet"
      parentCategory="Sähkökalusteet"
      previousParentCategory="Vesiputkien reititys ja muut valinnat"
      currentStep="electrical-appliances"
      nextRoute="/heating"
      imageMap={{
        
      }}
      checkMissingSelections={checkMissingSelections}
    />
  );
}
